<template>
    <v-btn
        class="text-none px-4 rounded-xl"
        color="#f5f5f5"
        large
        :disabled="!klarnaAppLoaded"
        @click="createFlow"
    >
        <slot></slot>
    </v-btn>
</template>

<script>
    import KlarnaService from '../../services/KlarnaService';

    export default {
        props: {
            userId: {
                type: String,
                default: null,
            },
        },
        data() {
            return {
                klarnaAppLoaded: false,
            };
        },
        mounted() {
            const vm = this;
            this.klarnaService = new KlarnaService({
                autoClose: true,
                hideTransitionOnFlowEnd: true,
                onAbort: () => {
                  this.onAbort();
                },
                onError: error => {
                  this.onError('Klarna on Error called', error)
                },
                onReady: () => {
                  this.$emit('loaded');
                },
                // onClose: () => {
                //     this.onClose();
                // },
            });


            this.$emit('loading');
            this.klarnaService.init()
                .then(() => {
                    this.$emit('loaded');
                    this.klarnaAppLoaded = true;
                })
                .catch((err) => {
                  this.$emit('loaded');
                  this.onError('Error loading Klarna App', err);
                });
        },
        methods: {
            createFlow() {
                this.$emit('loading');
                Vue.backendApi().user(this.userId || this.$store.state.user.id)
                    .createKlarnaAccountDetailsFlow()
                    .then((response) => {
                        this.$emit('loaded');
                        this.startFlow(response.data);
                    })
                    .catch((err) => this.onError('Error creating flow', err));
            },
            startFlow(data) {
                const vm = this;
                this.klarnaService.startFlow(data.client_token, {
                    onFinished() {
                        vm.$emit('onFinished', {
                            ...data,
                            provider: 'KLARNA',
                        });
                    },
                });
            },
            onError(title, err) {
                this.$emit('loaded');
                this.$swal({
                    type: 'error',
                    title,
                    text: err.message,
                });
            },
            onAbort() {
                this.$emit('loaded');
            },
        },
    };
</script>
